'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const eventDrawRoutes = [
  {
    path: 'draws',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.draw.list',
        props: true,
        component: () => import('../views/DrawListView.vue'),
      },
      // {
      //   path: ':drawId',
      //   component: EmptyRouterView,
      //   props: true,
      //   children: [
      //     {
      //       path: '',
      //       name: 'event.draw.detail',
      //       component: () => import('../views/DrawDetailView.vue'),
      //     },
      //   ],
      // },
    ],
  },
];

export const eventManageDrawRoutes = [
  {
    path: 'draws',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.manage.draw.list',
        props: true,
        component: () => import('../views/ManageDrawListView.vue'),
      },
      {
        path: 'add',
        name: 'event.manage.draw.add',
        props: true,
        component: () => import('../views/ManageDrawAddView.vue'),
      },
      {
        path: ':drawId',
        component: EmptyRouterView,
        props: true,
        children: [
          // {
          //   path: '',
          //   name: 'event.manage.draw.detail',
          //   props: true,
          //   component: () => import('../views/ManageDrawDetailView.vue'),
          // },
          {
            path: 'edit',
            name: 'event.manage.draw.edit',
            props: true,
            component: () => import('../views/ManageDrawEditView.vue'),
          },
        ],
      },
    ],
  },
];
